import { initializeApp, type FirebaseApp } from 'firebase/app'

let app: FirebaseApp | null = null
export function initializeFirebase(): FirebaseApp {
  if (app) return app
  const productionFirebase = {
    apiKey: 'AIzaSyCafG72rSWE956u8rRiEQML2EaSlAHtKjM',
    authDomain: 'passionequip.firebaseapp.com',
    projectId: 'passionequip',
    storageBucket: 'passionequip.firebasestorage.app',
    messagingSenderId: '80855037333',
    appId: '1:80855037333:web:e9102ea05c3c268374729c',
  }
  const devFirebase = {
    apiKey: 'AIzaSyCD0Sn56-G_sV1DDa2UzP_ilX3TSa89WXE',
    authDomain: 'pe-dev-53c61.firebaseapp.com',
    projectId: 'pe-dev-53c61',
    storageBucket: 'pe-dev-53c61.appspot.com',
    messagingSenderId: '749869421074',
    appId: '1:749869421074:web:d9330e9c498f049a0ebecb',
    measurementId: 'G-MCRL1ELDGF',
  }
  const firebaseConfig = process.env.NODE_ENV === 'production' ? productionFirebase : devFirebase
  firebaseConfig.authDomain = process.env.NODE_ENV === 'production' ? 'passionequip.com' : 'localhost:3000'
  app = initializeApp(firebaseConfig)
  return app
}
